var map = {
	"./A.png": "eQMT",
	"./J.png": "sRKA",
	"./K.png": "iTyU",
	"./P1.png": "CY9E",
	"./P2.png": "eplI",
	"./P3.png": "/CIL",
	"./P4.png": "h/SA",
	"./Q.png": "q9VM",
	"./S.png": "lh3y",
	"./T.png": "VxMD",
	"./W.png": "avSP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PtwR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hjzs ^\.\/.*\.png$
// module id = PtwR
// module chunks = 0